import { color, device, Common } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { Flex, Button, Avatar, Menu, Modal } = Common;

const ProfileContainer = styled.div`
  max-width: 660px;
  margin: auto;
`;

const ProfileBoxContainer = styled.div`
  background: ${color.light};
  margin-bottom: 16px;
  padding: 20px;

  @media ${device.laptop} {
    border-radius: 3px;
    margin: auto;
    margin-bottom: 16px;
    max-width: 660px;
    padding: 30px 19px 15px 22px;
    border: 1px solid ${color.gainsboro};
  }
`;

const ProfileTopContainer = styled.div`
  position: relative;
  border-bottom: 1px solid ${color.gainsboro};
`;

const ProfileAvatar = styled(Avatar)`
  cursor: pointer;

  & > img {
    height: 70px;
    width: 70px;
  }

  @media ${device.tablet} {
    & > img {
      height: 140px;
      width: 140px;
    }
  }
`;

const ModaAvatar = styled(Modal)`
  .ant-modal-content {
    position: relative;
    background: transparent;
    box-shadow: none;
    height: 310px;
    width: 310px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-modal-content img {
    height: 308px;
    width: 308px;
    border: none;
  }

  .ant-modal-close-x {
    display: none;
  }

  .ant-modal-close-x svg {
    width: 10px;
    height: 10px;
    top: 10px;
    left: 10px;
    position: absolute;
  }
`;

const ProfileStatsContainer = styled(Flex)`
  margin: 16px 0;

  > div {
    margin: 0px 8px;

    :first-child {
      margin-left: 0px;
    }
  }
`;

const ProfileStats = styled.div`
  padding: 0;

  @media ${device.tablet} {
    padding-right: 24px;
  }
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `};
`;

const ProfileButtonWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;

  @media ${device.tablet} {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const ProfileButton = styled(Button)`
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding: 0 9px;
  min-width: 77px;

  ${({ type, color: colorProp }) =>
    type === 'default' &&
    css`
      border-color: ${colorProp || color.downgray};
      color: ${color.downgray};
    `}
`;

const ProfileMoreNav = styled(Flex)`
  span {
    color: ${color.downgray};
    margin: 0 1.5px;
  }
`;

const PinnedPostContainer = styled.div`
  background: ${color.light};
  border: solid 1px ${color.gainsboro};
  border-left: solid 5px ${color.primary};
  margin-bottom: 20px;
`;

export const ProfileUsernameContainer = styled(Flex)`
  width: 100%;
  flex-direction: column;

  @media ${device.tablet} {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
`;

export const ProfileTopHeaderButtonContainer = styled(Flex)`
  padding: 0 10px 0 0;

  @media ${device.tablet} {
    align-items: center;
    justify-content: space-between;
    padding: 0 10px 0 10px;
  }
`;

export const MenuWrapper = styled(Menu)`
  border-radius: 3px;
  border: solid 1px ${color.gainsboro};
`;

export {
  ProfileContainer,
  ProfileBoxContainer,
  ProfileTopContainer,
  ProfileStats,
  ProfileStatsContainer,
  PinnedPostContainer,
  ProfileButton,
  ProfileAvatar,
  ProfileMoreNav,
  ProfileButtonWrapper,
  ModaAvatar,
};
